import { Loader } from "@allwyn/design-system/src/loader/loader";
import { useGdpr } from "@allwyn/gdpr/composables/use-gdpr";
import { NgOpenPageRequest, NgGamesLobbyOpenPage } from "@allwyn/ng/model/ng-open-page-request";
import { NgOpenPageResponse } from "@allwyn/ng/model/ng-open-page-response";
import { showGameHelpPopup } from "@allwyn/ng/ng-game-help";
import { useRgLimitsPopup } from "@allwyn/ng/rg-limits/use-rg-limits-popup";
import { httpClient } from "@allwyn/utils/http-clients/http-client";

export async function ngOpenPage(key: string, customInfo: string | any) {
    // total fallback
    let url: string = null;
    // eslint-disable-next-line
    let blank = false;
    key = typeof key === "string" ? key.toLowerCase() : key;
    customInfo = typeof customInfo === "string" ? customInfo.toLowerCase() : customInfo;

    // ignore solo gameslobby - it happens when user recarges money and then clicks "Zpět do nabídky her"
    // in this case user can miss screen "your bet has been placed"
    if (key === "gameslobby" && !customInfo) {
        return;
    } else if (key == "externalbetdetails") {
        url = "/moje-sazky/detail/" + customInfo.GameInstanceID;
    } else if (key == "helpgame") {
        showGameHelpPopup(customInfo);
        return;
    } else if (key == "preferencecenter") {
        url = await useGdpr().getLinkToPrefCenter();
        blank = true;
    } else if (key == "rglimits") {
        const { showRgPopup } = useRgLimitsPopup();
        await showRgPopup();
        ng_fw.closeMyAccount();
        return;
    } else {
        Loader.show();
        try {
            const response = await httpClient.get<NgOpenPageResponse>("/api/ng/open-page", {
                params: makeRequest(key, customInfo),
            });
            url = response.data.url;
            blank = response.data.openMode === "new";
        } catch (error) {
            console.error(error);
        }
    }

    if (!url) {
        // default
        url = "/centrum-podpory";
    }

    if (blank) {
        Loader.hide();
    }

    window.open(url, blank ? "_blank" : "_self");
}

function makeRequest(
    key: string,
    customInfo: string | Record<string, string> | NgGamesLobbyOpenPage
): NgOpenPageRequest {
    if (key == "gameslobby") {
        const info = customInfo as NgGamesLobbyOpenPage;
        return {
            key: key,
            verticals: info.verticals.join("|"),
            provider: info.provider?.toLowerCase(),
            subProvider: info.subprovider?.toLowerCase(),
        };
    } else if (key == "playerlimitedaccess") {
        return {
            key,
        };
    } else {
        return {
            key,
            info: customInfo?.toString(),
        };
    }
}
